module.exports = __webpack_public_path__ + "img/download_dialog.6a883daa.jpg";